import { $api } from "../generated/client";

type UseManualSizeBiasProductsQueryOptions = {
  shopId: string;
  page?: number;
  pageSize?: number;
  search?: string;
  sortBy?: "title" | "manualSizeBias";
  sortOrder?: "asc" | "desc";
};

export default function useManualSizeBiasProducts({
  shopId,
  page = 1,
  pageSize = 30,
  search,
  sortBy,
  sortOrder,
}: UseManualSizeBiasProductsQueryOptions) {
  return $api.useQuery("get", "/shops/{shopId}/sizing/manual-bias/products", {
    params: {
      path: { shopId },
      query: {
        page,
        pageSize,
        search: search || undefined,
        sortBy,
        sortOrder,
      },
    },
  });
}
